<template>
  <div>
    <v-card class="my-4" flat>
      <v-card-title>{{ title }}</v-card-title>
      <div>
        <v-file-input
          :accept="accept"
          :show-size="true"
          ref="myfile"
          outlined
          dense
          v-model="fileRecords"
          label="Upload images"
          @change="fileAdded()"
          :disabled="!fileNameRoot || loading"
          :loading="loading"
        ></v-file-input>
        <div v-if="!fileNameRoot" class="caption">
          Files can't be loaded until the item on this page is given a name.
        </div>
        <div
          class="d-flex flex-row flex-wrap justify-center justify-sm-start imageRow"
        >
          <div v-for="(file, i) in allFiles" :key="i">
            <v-card
              class="text-center my-2 mr-3 pa-2"
              style="position: relative"
            >
              <img
                :src="'https://www.eyedock.com' + path + file.file"
                height="180"
                :class="file.active ? '' : 'removedImage'"
              />
              <v-btn
                small
                fab
                @click="allFiles[i].active = !allFiles[i].active"
                style="position: absolute; right: 10px; top: 10px"
                class="ma-2"
              >
                <!-- :color="file.active ? 'red' : 'green'" -->
                <v-icon small>
                  {{
                    file.active ? "mdi-trash-can-outline" : "mdi-restore"
                  }}</v-icon
                >
                <!-- {{ file.active ? "Remove" : "Un-Remove" }} -->
              </v-btn>

              <!-- <v-btn v-else text @click="removeImage(i)"
              ><v-icon color="red">mdi-delete</v-icon>Remove</v-btn
            > -->
              <div
                v-if="!file.active"
                class="caption"
                style="position: absolute; left: 40%; top: 45%"
              >
                (removed)
              </div>
            </v-card>
          </div>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
// import Name from "../dir/file";
import axios from "axios";

export default {
  name: "ImageBrowserUploader",
  props: {
    path: null, // usually '/images/xxx/', todo check for backslashes at beginning and end
    previousFiles: {
      // an array of images that are already in the database for this concept
      type: Array,
      default: () => {
        return [];
      },
    },

    fileNameRoot: null, // files will be named this + date. If file exists the server will append "_1", "_2", etc
    accept: {
      type: String,
      default: "image/*",
    },
    limit: {
      type: Number,
      default: 10,
    },
    title: { type: String, default: "Images" },
  },
  data: function () {
    return { fileRecords: [], loading: false, allFiles: [] };
  },
  methods: {
    // toggleActive(i) {
    //   this.allFiles[i].active = !this.allFiles[i].active;
    //   this.emitFileList();
    // },

    dateString() {
      let today = new Date();
      var yyyy = today.getFullYear();
      var mm = today.getMonth() + 1; // getMonth() is zero-based
      var dd = today.getDate();
      return String(10000 * yyyy + 100 * mm + dd); // Leading zeros for mm and dd
    },
    fileAdded() {
      // console.log(this.fileRecords);
      if (!this.fileNameRoot || !this.fileRecords) return;
      var formData = new FormData();
      //   var imagefile = this.fileRecords;
      formData.append("file", this.fileRecords);
      formData.append("path", this.path);
      formData.append("name", `${this.fileNameRoot}_${this.dateString()}`);
      this.imageLoading = true;
      axios
        .post(
          "https://www.eyedock.com/fileUploader/simpleUploads.php",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          let d = response.data;
          // console.log(d);
          if (d.success && d.name) {
            // this.newFiles.push(d.name);
            if (this.limit == 1) {
              this.allFiles = [{ file: d.name, new: false, active: true }];
            } else {
              this.allFiles.push({ file: d.name, new: false, active: true });
            }
            // this.newImages.push(this.data.images.length - 1); // save the index of all new images
          }
        })
        .finally(() => {
          this.fileRecords = [];
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    emitFileList() {
      this.$emit("fileList", this.activeFiles);
    },
  },
  computed: {
    activeFiles: function () {
      let rtn = [];
      this.allFiles.forEach((file) => {
        if (file.active) rtn.push(file.file);
      });
      return rtn;
    },
  },
  watch: {
    activeFiles: { handler: "emitFileList", deep: true },
  },

  mounted() {
    this.previousFiles.forEach((file) => {
      if (file) this.allFiles.push({ file: file, new: false, active: true });
    });
    this.emitFileList();
  },
};
</script>

<style scoped>
.removedImage {
  opacity: 0.2;
}
</style>
